import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-listado-empresas',
  templateUrl: './listado-empresas.component.html',
  styleUrls: ['./listado-empresas.component.css'],
  standalone: true,
  imports: [
    CommonModule
  ],
  animations: [
    trigger('expandirFila', [
      state('collapsed', style({
        height: '0px',
        opacity: 0,
        overflow: 'hidden',
        padding: '0'
      })),
      state('expanded', style({
        height: '*',
        opacity: 1,
        overflow: 'visible',
        padding: '*'
      })),
      transition('collapsed <=> expanded', animate('250ms ease-in-out'))
    ])
  ]
})
export class ListadoEmpresas {
  empresas = [
    { id: 1, rut: '76.123.456-7', razonSocial: 'Empresa Uno Ltda.', estadoConfiguracion: true, expandidoRow: false, expandidoOpciones: false },
    { id: 2, rut: '77.987.654-3', razonSocial: 'Servicios Dos SpA', estadoConfiguracion: false, expandidoRow: false, expandidoOpciones: false }
  ];

  toggleRow(item: any) {
    item.expandidoRow = !item.expandidoRow;
  }

  toggleOpciones(item: any) {
    item.expandidoOpciones = !item.expandidoOpciones;
  }

  editarEmpresa(id: number) {
    console.log('Editar empresa', id);
  }
}
